var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "card align-center" }, [
        _c("img", {
          staticClass: "logo-color",
          attrs: { src: require("../../../static/logo.svg") }
        }),
        _vm._v(" "),
        _c("h4", [
          _vm._v("\n        Atualização dos Termos de Uso e Serviços\n      ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _c("p", [
            _vm._v(
              "\n          Com a evolução dos nossos produtos e serviços, nós da Donamaid estamos atualizando os nossos Termos de Uso e Serviços. Para continuar utilizando a Donamaid é necessário ler e aceitar o documento atualizado abaixo.\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "terms" }, [_c("TermsOfUse")], 1),
          _vm._v(" "),
          _c("p", { staticClass: "support" }, [
            _vm._v(
              "\n          Caso você tenha ficado com alguma dúvida estamos sempre a disposição, então não hesite em nos contatar\n          "
            ),
            _c(
              "b",
              { staticClass: "support", on: { click: _vm.openSupport } },
              [_vm._v("\n            clicando aqui.\n          ")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.submit($event)
              }
            }
          },
          [
            _c("div", { staticClass: "options" }, [
              _c("div", { staticClass: " radio-group" }, [
                _c("div", { staticClass: "option" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.accepted,
                        expression: "accepted"
                      }
                    ],
                    attrs: { id: "accept", type: "radio", name: "response" },
                    domProps: {
                      value: true,
                      checked: _vm._q(_vm.accepted, true)
                    },
                    on: {
                      change: function($event) {
                        _vm.accepted = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "option-text", attrs: { for: "accept" } },
                    [_vm._v("Declaro que li e aceito os Termos de Uso")]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn-group" }, [
              _c(
                "button",
                {
                  staticClass: "btn bg-purple",
                  class: { "btn--loading": _vm.loader },
                  attrs: { type: "submit" }
                },
                [_c("span", [_vm._v("Confirmar")])]
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-707d0c3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-707d0c3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TermsOfUse/Index.vue
// module id = null
// module chunks = 